import { addPopup } from '../actions/showPopover';
import isFunction from 'lodash/isFunction';

const notifyUser = ({ store, id, status, toast_text, timer, dispatch }) => {
  isFunction(dispatch) ? 
  dispatch(
    addPopup({
      status,
      toast_text,
      timer,
      id,
    })
  ): 
  store.dispatch(
    addPopup({
      status,
      toast_text,
      timer,
      id,
    })
  );
};

export default notifyUser;
